import { render, staticRenderFns } from "./irankish.vue?vue&type=template&id=386269d4&scoped=true"
import script from "./irankish.vue?vue&type=script&lang=js"
export * from "./irankish.vue?vue&type=script&lang=js"
import style0 from "./irankish.vue?vue&type=style&index=0&id=386269d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386269d4",
  null
  
)

export default component.exports